module.exports = __webpack_public_path__ + "media/bambous.30e18705.mp3";